import * as mutation_types from '../mutation-types'

// initial state
const state = {
    name: ''
}

// mutations
const mutations = {
    [mutation_types.ORG_NAME_SET] (state, orgName) {
        state.name = orgName;
    },
}

export default {
    state,
    mutations
}
